function appSearch(term) {
    if (term !== undefined && term.length > 0) {
        window.location.href = "/" + window.App.Locale.Routes.Search + "/" + encodeURIComponent(term);
    }
}
window.searchBoxState = "hidden";

$(document).ready(function() {

    $('.app-search-box').on('keydown', function(evt) {
        if (evt.keyCode == 13){
            evt.preventDefault();
            appSearch($(this).val());
        }    
    });

    $('.app-search-close-button').on('click', function() {
        window.searchBoxState = "hidden";
        $('.app-search-box').hide("slide", { direction: "right" }, 250);
        $('#mainMenu').fadeIn();
        $('#mainMenu').removeClass('hidden-menu');
    });

    $('.app-search-button').on('click', function(evt) {
        $('#mainMenu').fadeOut().addClass('d-none');
        $('#search-menu-layer').addClass('hidden-menu');
        $('#search-menu-layer').addClass('col-md-10');
        $('#idiomas').addClass('d-none');
        $('#social-menu').addClass('d-none');
        $('#search-close-button').removeClass('d-none');
        if (window.searchBoxState == "visible") {
            appSearch($('.app-search-box').val());
        } else {
            $('.app-search-box').show("slide", { direction: "right" }, 400);
            window.searchBoxState = "visible";
        }

        $('#mainMenu').fadeOut();
        $('#mainMenu').addClass('hidden-menu');
    });

    $(".app-search-box").autocomplete({
        source: function(request, response) {
            // Fetch data
            $.ajax({
                url: "/api/search?limit=3&term=" + encodeURIComponent(request.term),
                type: 'get',
                dataType: "json",
                success: function(data) {
                    response(data.results);
                }
            });
        },
        select: function(event, ui) {
            return false;
        },
        focus: function(event, ui) {
            return false;
        },
    }).data('ui-autocomplete')._renderItem = function(ul, item) {
        var searchItemGroup = $("<li>")
            .addClass("search-group-title")
            .attr("value", item.text)
            .html(item.text);

        var ret = searchItemGroup
            .appendTo(ul);

        item.children.forEach(itemChild => {
            var title = itemChild.content;
            if (title === undefined) {
                title = itemChild.title;
            }

            var searchItemLink = $("<a>")
                .attr("href", itemChild.url)
                .attr('target', '_blank')
                .html(title);

            var searchItemGroup = $("<li>")
                .addClass("search-group-item")
                .attr("value", itemChild.url)
                .append(searchItemLink);

            searchItemGroup.appendTo(ul);
        });

        return ret;
    };;
});